export const PartnershipSceneTranslation = {
  fi: {
    PartnershipScene: {
      title: 'Kumppanuudet',
      tabInvites: 'Saapuvat kutsut',
      tabPartnerships: 'Aktiiviset kumppanuudet',
      partnerName: 'Huoltokumppani',
      createdAt: 'Kutsu vastaanotettu',
      startedAt: 'Aloituspäivämäärä',
      actions: 'Toiminnot',
      accept: 'Hyväksy',
      reject: 'Hylkää',
      endPartnership: 'Päätä asiakkuus',
      acceptConfirmTitle: 'Hyväksytäänkö kutsu?',
      acceptConfirmDescription: 'Huoltokumppanuus astuu voimaan hyväksynnän jälkeen.',
      acceptConfirm: 'Hyväksy',
      acceptSuccess: 'Kutsu hyväksyttiin.',
      rejectConfirmTitle: 'Hylätäänkö kutsu?',
      rejectConfirmDescription: 'Kutsu merkitään hylätyksi. Tätä ei voi perua.',
      rejectConfirm: 'Hylkää',
      rejectSuccess: 'Kutsu hylättiin.',
      endConfirmTitle: 'Päätetäänkö asiakkuus?',
      endConfirmDescription: 'Asiakkuus merkitään päättyneeksi. Tätä ei voi perua.',
      endConfirm: 'Päätä asiakkuus',
      endSuccess: 'Asiakkuus päätettiin.',
      emptyInvites: 'Ei saapuvia kutsuja.',
      emptyPartnerships: 'Ei aktiivisia kumppanuuksia.',
      confirmCancel: 'Peruuta',
      selectGroups: 'Sallitut ryhmät',
      selectGroupsRequired: 'Valitse vähintään yksi ryhmä.',
      noGroups: 'Yrityksellä ei ole ryhmiä.',
      groups: 'Ryhmät',
      editGroups: 'Muokkaa ryhmiä',
      editGroupsTitle: 'Muokataan ryhmäoikeuksia',
      editGroupsDescription:
        'Valitse ryhmät, joiden ajoneuvot huoltokumppani näkee huoltokutsuliittymässä.',
      editGroupsSave: 'Tallenna',
      editGroupsSuccess: 'Ryhmäoikeudet päivitettiin.',
      acceptGroupsDescription:
        'Valitse ryhmät, joiden ajoneuvoihin huoltokumppanilla on oikeus huoltokutsuliittymässä.',
    },
  },
};
